// UQ-id-ID
module.exports = {
  "forTest": "test for UQ-id-ID",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "Official Styling",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "Pilih berdasarkan",
  "text_filter": "Filter",
  "text_styling_book_search_results_number": "{total} hasil",
  "text_active_filters": "Filter Aktif",
  "text_styling_book_clear_all_filters": "Hapus semua",
  "text_styling_book_search_by_feature": "Cari berdasarkan koleksi",
  "text_styling_book_search_by_category": "Cari berdasarkan kategori",
  "text_styling_book_staff_customer_filter_all": "Semua",
  "text_styling_book_search_by_coordinate": "Cari berdasarkan kata kunci",
  "text_styling_book_staff_customer_filter_title": "Diposting oleh",
  "text_styling_book_search_by_height": "Cari berdasarkan tinggi badan",
  "text_styling_book_search_by_hashtag": "Cari berdasarkan hashtag",
  "text_styling_book_staff_customer_filter_customer_styling": "Pelanggan",
  "text_styling_book_staff_customer_filter_staff_styling": "Staf UNIQLO",
  "text_apply_search_filter": "Terapkan",
  "text_styling_book_no_results": "Hasil tidak ditemukan",
  "text_error_title": "Layanan untuk sementara tidak tersedia",
  "text_503_error_description-1": "Mohon maaf, telah terjadi kesalahan.",
  "text_503_error_description-2": "Silakan coba lagi nanti atau kembali ke halaman sebelumnya dengan menggunakan tombol kembali pada browser Anda.",
  "text_503_error_instruction": "Jika Anda memiliki pertanyaan, silakan buka halaman HUBUNGI KAMI.",
  "text_styling_book_go_to_top": "Halaman utama UNIQLO",
  "text_contactus": "Hubungi kami",
  "text_wishlist": "Wishlist",
  "text_membership_info": "Keanggotaan",
  "text_wearing_items": "Item Outfit",
  "text_color": "Warna",
  "text_size": "Ukuran",
  "text_stylehint_non_listed_items_message_01": "*Produk yang dipakai dan tidak dicantumkan diatas adalah merk lain atau item season lama UNIQLO.",
  "text_styling_book_related_styling_title": "Anda mungkin juga suka",
  "text_style_styling_date_update": "Update",
  "text_styling_book_hashtag_title": "Hashtag",
  "currency_format": "Rp{price}",
  "text_404": "Halaman tidak ditemukan",
  "text_official_styling_top_page_link": "Halaman utama Official Styling",
  "text_stylehint_top_page_link": "Halaman utama StyleHint",
  "text_breadcrumbs_top": "UNIQLO",
  "text_a11y_close": "Tutup",
  "text_log_in": "Masuk",
  "text_app_update_dialog_cancel": "Batal",
  "text_menu": "Menu",
  "text_copyright": "Hak Cipta © UNIQLO Co., Ltd. Semua hak dilindungi undang-undang.",
  "text_stylehintapp": "StyleHint App",
  "text_styling_book_official_styling_page_title": "Official Styling",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "Koleksi terbaru",
  "text_styling_book_sort_popular": "Paling populer",
  "text_styling_book_search_by_color": "Cari berdasarkan warna",
  "text_filter_clear_all_category": "Hapus semua kategori",
  "text_styling_book_filter_height_over": "≧",
  "text_styling_book_filter_height_under": "≦",
  "text_show_all": "Tampilkan semua",
  "text_error_description": "Telah terjadi kesalahan sistem. Silakan coba lagi atau kembali lagi nanti.",
  "text_system_error": "Terjadi kesalahan pada sistem.",
  "text_ok": "OK",
  "text_login_required": "Wajib Masuk",
  "text_login_request": "Mohon menuju ke halaman Masuk.",
  "text_error_failed_sort_product": "Gagal mengurutkan produk dengan kriteria yang Anda pilih. Harap terapkan urutan lagi.",
  "text_error_failed_update_filter_criteria": "Gagal memperbarui kriteria filter. Silakan coba lagi.",
  "text_meta_title_postfix": "| UNIQLO ID",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "Wanita",
  "text_styling_book_meta_men": "Pria",
  "text_styling_book_meta_kids": "Anak",
  "text_styling_book_meta_baby": "Bayi",
  "text_styling_book_official_gender_meta_description": "Telusuri lookbook kami dan temukan gaya {gender} yang sempurna di musim ini! Dapatkan produk pada lookbook atau tambahkan di wishlist Anda untuk berbelanja nanti.",
  "text_styling_book_official_gender_meta_title": "Telusuri seasonal looks | {gender} | Official Styling {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "Ide styling {gender} 「{filterOptions}」 {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "Dapatkan ide styling {gender} 「{filterOptions}」dengan produk fashion dari {brand}. Lihat cara styling dengan produk yang sedang tren.",
  "text_styling_book_official_detail_meta_title": "Dapatkan look produk「{officialProducts}」{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "Cek gaya terbaru untuk 「{officialProducts}」dan dapatkan semuanya di {brand}.com sekarang!",
  "text_styling_book_stylehint_gender_meta_title": "Temukan ide styling baru | {gender} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "Temukan gayamu! Telusuri ide gaya {gender} dari pelanggan dan Staf {brand} kami yang diposting melalui aplikasi StyleHint.",
  "text_styling_book_stylehint_filter_meta_title": "Ide styling {gender}「{filterOptions}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "Ide outfit {userName}({storeName}) {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "Ide outfit {userName} {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "Ide outfit {userName}({height}) {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "Cek ide styling untuk「{stylehintProducts}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "Dapatkan ide outfit staf {brand}({storeName}) {staffName}({height}). Lihat bagaimana gaya mereka dengan produk yang sedang tren.",
  "text_styling_book_stylehint_ins_user_meta_description": "Dapatkan ide outfit pengguna Instagram「{userName} menggunakan produk fashion {brand} untuk mix-and-match outfit. Cek pengguna lainnya dan lihat gaya mereka dengan produk yang sedang tren.",
  "text_styling_book_stylehint_customer_user_meta_description": "Dapatkan ide outfit {userName} ({height}) menggunakan produk {brand} agar tetap trendi. Lihat produk yang dikenakan oleh model di toko online.",
  "text_styling_book_stylehint_detail_meta_description": "Temukan gaya baru untuk「{stylehintProducts}」dari pelanggan dan staf {brand} kami. Dapatkan hanya di {brand}.com sekarang!",
  "text_styling_book_stylehint_filter_meta_description": "Dapatkan「{searchCount}」ide pakaian 「{filterOptions}」 menggunakan fashion item {brand}. Lihat produk terbaru & yang sedang tren di toko online.",
  "text_styling_book_stylehint_styling_id_alt_tag": "Ide outfit {brand} STYLING BOOK <{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "Ide styling {brand} STYLING BOOK <{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "Temukan ide styling「{officialProducts}」",
  "text_styling_book_stylehint_detail_id_alt_tag": "Temukan ide outfit「{stylehintProducts}」",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "Ide outfit {gender}「{hashtag}」",
  "text_styling_book_stylehint_feature_alt_tag": "Ide styling {gender} 「{feature}」",
  "text_style_model_height": "cm",
  "text_503_error_description": "Mohon maaf. Telah terjadi kesalahan. Silakan akses situs ini nanti atau kembali ke halaman sebelumnya dengan menggunakan tombol kembali pada browser.",
  "text_styling_book_meta_official_styling": "ide styling",
  "text_styling_book_meta_stylehint": "ide outfit",
  "text_limited_offer_until_date": "{flagName} hingga {date}",
  "text_online_store_exclusive_limited_offer_until_date": "{flagName} hingga {date}",
  "text_app_membership_exclusive_limited_offer_until": "{flagName} hingga {date}",
  "text_csoon_early": "Tersedia awal {month}",
  "text_csoon_mid": "Tersedia pertengahan {month}",
  "text_csoon_late": "Tersedia akhir {month}",
  "text_men": "Pria",
  "text_women": "Wanita",
  "text_kids": "Anak",
  "text_baby": "Bayi",
  "text_unisex": "Uniseks",
  "text_app_membership_exclusive_limited_offer": "Penawaran Khusus Member App",
  "text_styling_book_gender_menu_kids_and_baby": "Anak / Bayi",
  "text_styling_book_meta_kids_and_baby": "KIDS・BABY",
  "text_a11y_favorites_add": "Tambahkan ke wishlist",
  "text_close": "Tutup",
  "text_error_wishlist_max": "Anda tidak dapat menambahkan produk ke wishlist Anda karena melebihi maksimal wishlist 999 produk.",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "Tidak ada gambar",
  "text_wearing_size_code01": "Ukuran pakaian: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "",
  "text_locale_th": "",
  "text_locale_id": "Bahasa Indonesia",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "",
  "text_product_unavailable": "Produk ini sudah tidak diproduksi.",
  "text_product_display_markdown": "",
  "text_color_white": "Putih",
  "text_color_gray": "Abu-abu",
  "text_color_black": "Hitam",
  "text_color_pink": "Pink",
  "text_color_red": "Merah",
  "text_color_orange": "Oranye",
  "text_color_beige": "Beige",
  "text_color_brown": "Cokelat",
  "text_color_yellow": "Kuning",
  "text_color_green": "Hijau",
  "text_color_blue": "Biru",
  "text_color_purple": "Ungu",
  "text_promotion": "Promosi",
  "text_styling_promotion_hashtag": "Promosi",
  "text_coming_soon": "Segera datang.",
  "text_markdown": "Harga turun",
  "text_multibuy_markdown": "Beli banyak, harga turun",
  "text_multibuy_limited_offer_until_date": "Beli banyak, penawaran terbatas hingga {date}",
  "text_app_membership_exclusive_multi_buy_until": "",
  "text_app_membership_exclusive_multi_buy": "",
  "text_app_membership_exclusive_limitedoffers_until": "",
  "text_item_preorder_color_size_only": "",
  "text_item_resale_color_size_only": ""
}; // generated at Mon Mar 24 2025 11:01:48 GMT+0800 (Hong Kong Standard Time)